<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <!-- Header -->
    <div class="py-4 flex justify-between items-center dashboard-header px-6">
      <div class="flex items-center gap-4">
        <button 
          mat-icon-button 
          (click)="goBack()" 
          class="text-white hover:bg-white/10">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h2 class="text-xl text-white font-semibold mb-0">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.TITLE' | translate }}</h2>
      </div>
    </div>

    <!-- Content -->
    <div class="@container relative w-full grow p-6 space-y-6">
      
      <!-- Loading Spinner -->
      <div *ngIf="spinnerService.getSpinnerState('partner-detail') | async" 
           class="flex justify-center items-center min-h-[400px]">
        <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
      </div>
      
      <!-- Content when not loading -->
      <div *ngIf="!(spinnerService.getSpinnerState('partner-detail') | async)">

        <!-- Partner Information -->
        <app-btb-partner-info 
          [partnerInfo]="partnerInfo"
          [showEmail]="true"
          [showCopyButton]="true"
          (copyRegistrationLink)="copyRegistrationLink()">
        </app-btb-partner-info>

        <div class="mt-8"></div>

        <!-- Tabs Navigation -->
        <app-btb-tabs 
          [tabs]="tabs"
          [activeTab]="activeTab"
          (tabChange)="onTabChange($event)">

          <!-- Transactions Tab -->
          <div [hidden]="activeTab !== 'transactions'">
            <app-btb-transactions-list
              [transactions]="userTransactions"
              [filterFields]="filterTransactionsFields"
              [filteredCount]="filteredCounts.userTransactions"
              (filteredCountChange)="onTransactionsFilteredCountChange($event)"
              (buscarPorFechasEvent)="onBuscarPorFechas($event)"> <!-- NUEVO  para cargar las fechas que vienen de btb-transaction-list-->
            </app-btb-transactions-list>
          </div>
          
          <!-- Invoices Tab -->
          <div [hidden]="activeTab !== 'invoices'">
            <app-btb-invoices-list
              [allInvoices]="allInvoices"
              [filterFields]="filterFields"
              [showAddButton]="false"
              [isBackoffice]="true"
              [pendingTotal]="pendingTotal"
              [totalBilling]="totalBilling"
              (invoiceAction)="onInvoiceAction($event)"
              (filteredCountChange)="onFilteredCountChange($event)">
            </app-btb-invoices-list>
          </div>

          <!-- Commission Tab -->
          <div *ngIf="activeTab === 'commission'">
            <app-btb-commission-list 
              [conditions]="condicionesComision"
              [showEditButton]="true"
              (editConditions)="onEditConditions()">
            </app-btb-commission-list>
          </div>
        </app-btb-tabs>

      </div>
    </div>
  </div>

  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>